import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import FenixBoxMessage from '@pedidosya/web-fenix/system/BoxMessage';
import { MESSAGE_TYPE } from './constants';

const Container = styled.div`
  width: 100%;
  max-width: 465px;
`;

function BoxMessage({
  type,
  onClose,
  title,
  message,
  onCallToAction,
  actionLabel,
}) {
  return (
    <Container>
      <FenixBoxMessage
        type={type}
        title={title}
        message={message}
        actionLabel={actionLabel}
        onClickAction={onCallToAction}
        onClose={onClose}
      />
    </Container>
  );
}

BoxMessage.defaultProps = {
  type: MESSAGE_TYPE.INFO,
};

BoxMessage.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  type: PropTypes.oneOf(Object.values(MESSAGE_TYPE)),
  onCallToAction: PropTypes.func,
  actionLabel: PropTypes.string,
};

export default BoxMessage;
